var _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _path9, _g4, _path10, _path11, _g5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoviral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 33,
    viewBox: "0 0 160 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4833_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.092 0C8.91652 0 4 4.86337 4 10.524C4 15.9455 8.51789 19.6661 14.6569 19.6661C17.4739 19.6661 19.6797 18.7891 21.3009 17.2743L21.0085 18.6651H24.676L26.1376 8.92947H13.9128L13.461 12.2249H22.045C21.2477 14.7496 18.4041 16.2644 15.0024 16.2644C10.9629 16.2644 8.03952 14.1118 8.03952 10.2848C8.03952 6.37819 11.1223 3.42828 15.8528 3.42828C19.2545 3.42828 21.9387 4.91653 22.6562 7.54753L26.2705 6.00613C25.2872 2.39182 21.2743 0 16.092 0Z",
    fill: "#020CF5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1159 0C14.9405 0 10.0239 4.86337 10.0239 10.524C10.0239 15.9455 14.5418 19.6661 20.6808 19.6661C23.4979 19.6661 25.7037 18.7891 27.3248 17.2743L27.0324 19.3738H30.6999L32.1616 8.92947H19.9367L19.4849 12.2249H28.0689C27.2716 14.7496 24.428 16.2644 21.0263 16.2644C16.9868 16.2644 14.0634 14.1118 14.0634 10.2848C14.0634 6.37819 17.1462 3.42828 21.8767 3.42828C25.2784 3.42828 27.9626 4.91653 28.6801 7.54753L32.2945 6.00613C31.3111 2.39182 27.2982 0 22.1159 0Z",
    fill: "#EA3A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1037 0C11.9282 0 7.01172 4.86337 7.01172 10.524C7.01172 15.9455 11.5296 19.6661 17.6686 19.6661C20.4857 19.6661 22.6914 18.7891 24.3126 17.2743L24.0202 19.3738H27.6877L29.1494 8.92947H16.9245L16.4727 12.2249H25.0567C24.2594 14.7496 21.4158 16.2644 18.0141 16.2644C13.9746 16.2644 11.0512 14.1118 11.0512 10.2848C11.0512 6.37819 14.134 3.42828 18.8645 3.42828C22.2662 3.42828 24.9504 4.91653 25.6679 7.54753L29.2822 6.00613C28.2989 2.39182 24.286 0 19.1037 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.999 19.6661C45.0682 19.6661 49.7455 14.723 49.7455 9.16866C49.7455 3.90664 45.3871 0 38.9823 0C31.8866 0 27.2092 4.9431 27.2092 10.4974C27.2092 15.7595 31.5942 19.6661 37.999 19.6661ZM38.8229 3.42828C42.9687 3.42828 45.706 5.8201 45.706 9.38126C45.706 13.1816 42.7029 16.2378 38.1319 16.2378C34.0126 16.2378 31.2488 13.846 31.2488 10.2848C31.2488 6.4845 34.2784 3.42828 38.8229 3.42828Z",
    fill: "#020CF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0229 19.6661C51.0921 19.6661 55.7694 14.723 55.7694 9.16866C55.7694 3.90664 51.411 0 45.0062 0C37.9105 0 33.2332 4.9431 33.2332 10.4974C33.2332 15.7595 37.6182 19.6661 44.0229 19.6661ZM44.8468 3.42828C48.9926 3.42828 51.7299 5.8201 51.7299 9.38126C51.7299 13.1816 48.7269 16.2378 44.1558 16.2378C40.0366 16.2378 37.2727 13.846 37.2727 10.2848C37.2727 6.4845 40.3023 3.42828 44.8468 3.42828Z",
    fill: "#EA3A24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.011 19.6661C48.0801 19.6661 52.7575 14.723 52.7575 9.16866C52.7575 3.90664 48.399 0 41.9943 0C34.8985 0 30.2212 4.9431 30.2212 10.4974C30.2212 15.7595 34.6062 19.6661 41.011 19.6661ZM41.8348 3.42828C45.9806 3.42828 48.718 5.8201 48.718 9.38126C48.718 13.1816 45.7149 16.2378 41.1438 16.2378C37.0246 16.2378 34.2607 13.846 34.2607 10.2848C34.2607 6.4845 37.2904 3.42828 41.8348 3.42828Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4833_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.9225 19.3749L79.4929 0.293457H75.1345L65.142 15.5214L59.8534 0.293457H55.7341L62.4578 19.3749H66.9225Z",
    fill: "#020CF5"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9465 19.3749L85.5168 0.293457H81.1584L71.1659 15.5214L65.8773 0.293457H61.7581L68.4817 19.3749H72.9465Z",
    fill: "#EA3A24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9343 19.3749L82.5046 0.293457H78.1462L68.1537 15.5214L62.8651 0.293457H58.7458L65.4695 19.3749H69.9343Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4833_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6295 12.2791H98.3797L102.1 19.3749H106.432L102.499 11.9868C105.848 11.1895 107.788 8.82429 107.788 5.82123C107.788 2.4461 105.183 0.293457 101.064 0.293457H89.4237L86.7395 19.3749H90.6461L91.6295 12.2791ZM92.1078 9.01032L92.8519 3.61543H100.665C102.791 3.61543 103.934 4.57216 103.934 6.03383C103.934 7.68153 102.472 9.01032 99.9743 9.01032H92.1078Z",
    fill: "#020CF5"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6534 12.2791H104.404L108.124 19.3749H112.456L108.523 11.9868C111.871 11.1895 113.811 8.82429 113.811 5.82123C113.811 2.4461 111.207 0.293457 107.088 0.293457H95.4476L92.7634 19.3749H96.6701L97.6534 12.2791ZM98.1317 9.01032L98.8759 3.61543H106.689C108.815 3.61543 109.958 4.57216 109.958 6.03383C109.958 7.68153 108.496 9.01032 105.998 9.01032H98.1317Z",
    fill: "#EA3A24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6412 12.2791H101.391L105.112 19.3749H109.444L105.511 11.9868C108.859 11.1895 110.799 8.82429 110.799 5.82123C110.799 2.4461 108.195 0.293457 104.076 0.293457H92.4354L89.7512 19.3749H93.6579L94.6412 12.2791ZM95.1195 9.01032L95.8637 3.61543H103.677C105.803 3.61543 106.946 4.57216 106.946 6.03383C106.946 7.68153 105.484 9.01032 102.986 9.01032H95.1195Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4833_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.085 0.293457L109.594 19.3749H113.9L116.797 14.9367H127.613L129.154 19.3749H133.22L126.47 0.293457H122.085ZM123.839 4.06722L126.47 11.6148H118.949L123.839 4.06722Z",
    fill: "#020CF5"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.109 0.293457L115.618 19.3749H119.924L122.82 14.9367H133.637L135.178 19.3749H139.244L132.494 0.293457H128.109ZM129.863 4.06722L132.494 11.6148H124.973L129.863 4.06722Z",
    fill: "#EA3A24"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.097 0.293457L112.606 19.3749H116.911L119.808 14.9367H130.625L132.166 19.3749H136.232L129.482 0.293457H125.097ZM126.851 4.06722L129.482 11.6148H121.961L126.851 4.06722Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_4833_140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.17 19.3749H153.498L153.976 15.9998H140.555L142.761 0.293457H138.854L136.17 19.3749Z",
    fill: "#020CF5"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.194 19.3749H159.522L160 15.9998H146.579L148.785 0.293457H144.878L142.194 19.3749Z",
    fill: "#EA3A24"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.182 19.3749H156.509L156.988 15.9998H143.567L145.773 0.293457H141.866L139.182 19.3749Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4206 0.293457H82.514L79.8298 19.3749H83.7365L86.4206 0.293457Z",
    fill: "#020CF5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4446 0.293457H88.5379L85.8538 19.3749H89.7604L92.4446 0.293457Z",
    fill: "#EA3A24"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4324 0.293457H85.5257L82.8416 19.3749H86.7482L89.4324 0.293457Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3004 24.7423L91.2715 30.9472L90.2372 24.7423H88.8652L90.2267 32.3062H91.8414L94.8491 26.1961L95.8095 32.3062H97.4453L101.371 24.7423H99.9571L96.791 30.9472L95.799 24.7423H94.3004Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.087 32.422C107.873 32.422 109.71 30.4521 109.71 28.2504C109.71 26.175 107.989 24.6265 105.456 24.6265C102.67 24.6265 100.823 26.5964 100.823 28.7981C100.823 30.8735 102.554 32.422 105.087 32.422ZM105.414 25.8169C107.177 25.8169 108.316 26.8282 108.316 28.3241C108.316 29.9359 107.071 31.2316 105.129 31.2316C103.367 31.2316 102.216 30.2203 102.216 28.7244C102.216 27.1126 103.472 25.8169 105.414 25.8169Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.922 29.3775H114.834L116.375 32.3062H117.863L116.27 29.2933C117.599 29.0088 118.402 28.0818 118.402 26.8809C118.402 25.564 117.399 24.7423 115.848 24.7423H111.225L110.159 32.3062H111.51L111.922 29.3775ZM112.09 28.2187L112.407 25.9011H115.689C116.586 25.9011 117.082 26.3015 117.082 26.9335C117.082 27.6393 116.439 28.2187 115.373 28.2187H112.09Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M118.621 32.3062H125.502L125.67 31.1263H120.14L121.037 24.7423H119.687L118.621 32.3062Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.464 32.3062H130.464C133.397 32.3062 135.107 30.3783 135.107 28.2504C135.107 26.3015 133.609 24.7423 131.139 24.7423H127.53L126.464 32.3062ZM127.952 31.1474L128.691 25.9011H130.991C132.733 25.9011 133.725 26.9967 133.725 28.3241C133.725 29.8305 132.5 31.1474 130.516 31.1474H127.952Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.7277,
    cy: 26.9303,
    r: 1.94889,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4833_140",
    x: 0,
    y: 0,
    width: 30.2705,
    height: 27.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4833_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4833_140",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4833_140",
    x: 51.7341,
    y: 0.293457,
    width: 31.7588,
    height: 27.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4833_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4833_140",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4833_140",
    x: 82.7395,
    y: 0.293457,
    width: 29.0481,
    height: 27.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4833_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4833_140",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4833_140",
    x: 105.594,
    y: 0.293457,
    width: 31.626,
    height: 27.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4833_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4833_140",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_4833_140",
    x: 132.17,
    y: 0.293457,
    width: 25.8059,
    height: 27.0815,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4833_140"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4833_140",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoviral);
export default __webpack_public_path__ + "static/media/goviral.e7081a3b9a3e1faefa5e7e5519d70a8b.svg";
export { ForwardRef as ReactComponent };